/**
 * Generated from com.dataiku.dip.dataflow.exec.joinlike.ConditionsMode
 */
export enum ConditionsMode {
    AND = 'AND',
    OR = 'OR',
    NATURAL = 'NATURAL',
    CUSTOM = 'CUSTOM'
}